module.exports = __webpack_public_path__ + "img/logo-gold-167x57.055485c.svg";